var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55122 12.958L11.0079 15.4147L15.1024 9.6824M11.8268 2C9.35455 4.34778 6.06205 5.63547 2.65294 5.58789C2.21929 6.90902 1.99888 8.29082 2 9.68131C2 15.787 6.17532 20.9166 11.8268 22.3721C17.4784 20.9177 21.6537 15.7881 21.6537 9.6824C21.6537 8.25205 21.4244 6.8752 21.0007 5.58679H20.8348C17.3451 5.58679 14.1744 4.22414 11.8268 2Z",
    stroke: "currentColor",
    strokeWidth: 1.96537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.b23d9549e157585ece1060613bfc5734.svg";
export { ForwardRef as ReactComponent };